<form [formGroup]="racePointForm">
    <div formArrayName="attachedRaces">
        @for (group of attachedRaces.controls; track $index; let i = $index) {
        <div class="race-link-card" [formGroupName]="i">

            <!-- Ligne 1 : Sélection de la course & suppression -->
            <div class="row align-items-center">
                <mat-form-field appearance="outline" class="flex-grow">
                    <mat-label>Course</mat-label>
                    <mat-select MatInp formControlName="raceId">
                        @if (races$ | async; as races) {
                        @for (race of races; track race.id) {
                        <mat-option [value]="race.id">{{ race.name }}</mat-option>
                        }
                        }
                    </mat-select>
                    <mat-hint>Sélectionnez la course à associer</mat-hint>
                    @if (attachedRaces.controls[i].get('raceId')?.hasError('required')) {
                    <mat-error>La course est obligatoire</mat-error>
                    }
                </mat-form-field>

                <button matIconButton color="warn" type="button" (click)="removeRaceLink(i)" title="Délier la course">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>

            <!-- Ligne 2 : Métriques de la course -->
            <div class="grid-3-cols">

                <!-- Nb. passages -->
                <mat-form-field appearance="outline">
                    <mat-label>Passages</mat-label>
                    <input matInput type="number" formControlName="nbPassage" min="1">
                    <mat-hint>Nombre de passages</mat-hint>
                    @if (attachedRaces.controls[i].get('nbPassage')?.hasError('required')) {
                    <mat-error>Champ requis</mat-error>
                    } @else if (attachedRaces.controls[i].get('nbPassage')?.hasError('min')) {
                    <mat-error>Min. 1 passage</mat-error>
                    }
                </mat-form-field>

                <!-- Distance depuis le départ -->
                <mat-form-field appearance="outline">
                    <mat-label>Distance départ (km)</mat-label>
                    <input matInput type="number" step="0.1" formControlName="distanceFromStart">
                    <mat-hint>Cumulé (km)</mat-hint>
                    @if (attachedRaces.controls[i].get('distanceFromStart')?.hasError('required')) {
                    <mat-error>Distance requise</mat-error>
                    } @else if (attachedRaces.controls[i].get('distanceFromStart')?.hasError('min')) {
                    <mat-error>Doit être &ge; 0</mat-error>
                    }
                </mat-form-field>

                <!-- Altitude -->
                <mat-form-field appearance="outline">
                    <mat-label>Altitude (m)</mat-label>
                    <input matInput type="number" formControlName="elevation">
                    <mat-hint>Altitude au point</mat-hint>
                    @if (attachedRaces.controls[i].get('elevation')?.hasError('required')) {
                    <mat-error>Altitude requise</mat-error>
                    }
                </mat-form-field>

                <!-- D+ cumulé -->
                <mat-form-field appearance="outline">
                    <mat-label>D+ cumulé (m)</mat-label>
                    <input matInput type="number" formControlName="elevationFromStart">
                    <mat-hint>Dénivelé positif</mat-hint>
                    @if (attachedRaces.controls[i].get('elevationFromStart')?.hasError('required')) {
                    <mat-error>D+ requis</mat-error>
                    } @else if (attachedRaces.controls[i].get('elevationFromStart')?.hasError('min')) {
                    <mat-error>Doit être &ge; 0</mat-error>
                    }
                </mat-form-field>

            </div>

            <!-- Ligne 3 : Horaires et Barrières -->
            <div class="grid-2-cols">

                <!-- Date / Heure ouverture -->
                <mat-form-field appearance="outline">
                    <mat-label>Date / Heure d'ouverture</mat-label>
                    <input matInput type="datetime-local" formControlName="openingDate">
                    <mat-hint>Ouverture du point</mat-hint>
                </mat-form-field>

                <!-- Date / Heure fermeture -->
                <mat-form-field appearance="outline">
                    <mat-label>Date / Heure de fermeture</mat-label>
                    <input matInput type="datetime-local" formControlName="closingDate">
                    <mat-hint>Barrière horaire</mat-hint>
                </mat-form-field>

            </div>

        </div>
        }
    </div>

    <button matButton="elevated" type="button" (click)="addRaceLink()">Ajouter une course</button>
</form>